import React from 'react'
import classNames from 'classnames'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'
import { Notification } from '@zambezi/sdk/notification'

import style from './ConsentOverviewHeader.module.css'

function DateDisplay({ dateLabel, dateValue, dateFormat = 'DD MMM YYYY' }) {
  return dateValue
    ? `${dateLabel} ${formatDate(dateValue, dateFormat)}`
    : dateLabel
}

function generateNotificationStatus(onCancel, consentStatus) {
  if (onCancel) {
    return 'success'
  }
  if (consentStatus === 'WITHDRAWN') {
    return 'error'
  }
  return 'info'
}

export default function ConsentOverviewHeader({
  dateLabel,
  dateValue,
  description,
  onCancel,
  cancelLabel = 'CANCEL LABEL MISSING',
  consentStatus,
}) {
  return (
    <div className={classNames(style.container, 'js-consent-overview-header')}>
      <div className={classNames(style.content)}>
        <div className={`${style.description} js-description`}>
          {description}
        </div>
      </div>
      <Notification
        className="js-secondary-title"
        status={generateNotificationStatus(onCancel, consentStatus)}
        size="small"
        title={
          <span className="js-account-notification-title">
            <DateDisplay dateLabel={dateLabel} dateValue={dateValue} />
            {onCancel && (
              <div className={classNames(style.cancelArea)}>
                <button
                  className={`${style.cancelButton} zb-button-link  js-cancel-button`}
                  onClick={() => onCancel()}
                >
                  <span>{cancelLabel}</span>
                </button>
              </div>
            )}
          </span>
        }
      />
    </div>
  )
}
